export default __webpack_public_path__ + "static/media/wp.38b298bb.png";